export const colors = ['red', 'orange', 'blue', 'green', 'purple', 'pink', 'brown'];
